function t(a, o) {
  for (var e = o - a + 1, n = new Array(e), r = 0; r < e; r++)
    n[r] = a + r;
  return n;
}
export {
  t as range
};
